import { useLazyQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./PinCode.gql";

export const usePinCode = (props = {}) => {
  const { setPincodemessage, pinCodeCheckFun, pinCode, setSessionPinCode } =
    props;
  const { checkPinCodeQuery } = DEFAULT_OPERATIONS;

  const [checkPinCode, { data: pincodeData }] = useLazyQuery(
    checkPinCodeQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      onCompleted: (data) => {
        if (data?.pin_code?.status === "1") {
          localStorage.setItem("PinCode", pinCode);

          if (pinCodeCheckFun) {
            pinCodeCheckFun(true);
          } else {
            setSessionPinCode(pinCode);
          }
        } else {
          setPincodemessage(
            "Product Delivery is not Available to selected location"
          );
        }
      },
    }
  );

  return {
    checkPinCode,
    pincodeData,
  };
};
